import { makeStyles } from "@material-ui/core";
import { Grid, Tooltip, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { ThemeContext } from "../../theme/ThemeContext";

const useStyles = makeStyles((theme) => ({
  dialogbox: {
    "& .MuiDialog-paper": {
      maxWidth: "600px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));

export default function FilterOperationLOg(props) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const [dateOpen, SetDateOpen] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });
  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };
  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T00:00";

  const [payload, setPayload] = useState({
    userName: "",
    module: "",
    subModule: "",
    operationType: "",
    operationDetails: "",
    opResult: "",
  });

  const [error, setError] = useState({
    userName: false,
    module: false,
    subModule: false,
    operationType: false,
    operationDetails: false,
    opResult: false,
  });

  const handleClose = () => {
    setPayload({
      userName: "",
      module: "",
      subModule: "",
      operationType: "",
      operationDetails: "",
      opResult: "",
    });
    setOpen(false);
    SetDateOpen(props.open);
    setDiaLogBoxBlur(false);
  };

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
  };

  const handleSubmit = () => {
    if (
      payload.userName.trim() === "" &&
      payload.module.trim() === "" &&
      payload.subModule.trim() === "" &&
      payload.operationType.trim() === "" &&
      payload.operationDetails === "" &&
      payload.opResult === ""
    ) {
      Toast(t("COMMON154"), "error");
      return;
    }

    props.applyFilter(payload);
    setPayload({
      userName: "",
      module: "",
      subModule: "",
      operationType: "",
      operationDetails: "",
      opResult: "",
    });
    handleClose();
  };

  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => setOpen(true)}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <FilterOperationLOg />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <FilterOperationLOg />
            </FilterIcon>
          )}
        </span>
      </Tooltip>

      <DialogBox
        Header={
          <span
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            {t("COMMON006")}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("COMMON024")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          rowSpacing={2}
          style={{
            width: "100%",
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
          }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextfield
              label={t("Operator")}
              name="userName"
              value={payload.userName}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextfield
              label={t("Module")}
              name="module"
              value={payload.module}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextfield
              label={t("Sub Module")}
              name="subModule"
              value={payload.subModule}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextfield
              label={t("Operation")}
              name="operationType"
              value={payload.operationType}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextfield
              label={t("Operation Details")}
              name="operationDetails"
              value={payload.operationDetails}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
